import Vue from 'vue'
import VueRouter from 'vue-router'
import {UserRouter} from './routerModule/user';
import {AdminRouter} from './routerModule/admin';
import {WorkerRouter} from './routerModule/worker';
import {CommonRouter} from './routerModule/common';

Vue.use(VueRouter)
console.log({UserRouter,AdminRouter,CommonRouter})
const routes = [
  ...UserRouter,
  ...AdminRouter,
  ...WorkerRouter,
  ...CommonRouter
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
